/**
 * The contact points and external destinations the public site advertises.
 *
 * These were previously hardcoded per page, so a visitor could be handed either
 * support@zomtech.com or support@zom.ai depending on which page they landed on,
 * and the launch domain change had to be chased through a dozen files. Every
 * public surface reads from here instead.
 */

/**
 * The one support address used across the site.
 *
 * NOTE FOR REVIEW: set to the zom.ai address to match the launch domain.
 * Confirm the mailbox is monitored before launch, or point this at the address
 * that is.
 */
export const SUPPORT_EMAIL = "support@zom.ai";

/**
 * The privacy contact named in the privacy policy and legal documents.
 *
 * NOTE FOR REVIEW: deliberately still on zomtech.com. This is a legal contact
 * of record, so it is not switched to the launch domain until someone confirms
 * the zom.ai mailbox exists and that the change is fine to make in published
 * legal copy.
 */
export const PRIVACY_EMAIL = "privacy@zomtech.com";

/**
 * The external trust portal.
 *
 * NOTE FOR REVIEW: a real third-party subdomain, left on zomtech.com on purpose.
 * Do not point it at zom.ai until that host actually serves the portal.
 */
export const TRUST_PORTAL_URL = "https://trust.zomtech.com";

/** Display host for the trust portal link text. */
export const TRUST_PORTAL_LABEL = "trust.zomtech.com";

/** The one canonical Request Access destination. */
export const REQUEST_ACCESS_PATH = "/request-access";
